import { FixConversations } from "./../fix/FixConversations";
import { FixParser } from "./../fix/FixParser";
import { EventPublisher } from "./../EventPublisher";
import { Storage } from "./Storage";

export default function FixParserCtrl($scope, $http, $location, $window) {
  const DONATION_THRESHOLD = 150;
  const storage = new Storage();

  /**
   * @type {string}
   */
  $scope.query = $location.search().q;
  if (!$scope.query) {
    $scope.query = "";
  }
  $scope.dialect = storage.dialect();
  $scope.messages = [];
  $scope.conversations = [FixConversations.EMPTY];
  $scope.clearOutput = true;
  $scope.expand = storage.showMessageDetails();
  $scope.filter = {
    showAdminMessages: storage.showAdminMessages(),
    showHeartbeats: storage.showHeartbeats(),
    text: "",
    caseInsensitive: storage.caseInsensitive(),
    conversation: $scope.conversations[0],
  };

  const textarea = $("#fixInput");
  const loading = $("#loading");
  const $filterForm = $("#filterForm");
  const $filterFormTop = $filterForm.offset().top;

  // noinspection JSUnresolvedVariable
  const eventPublisher = new EventPublisher(() => $window);

  let parseTimeStart = 0;

  $scope.parties = [];

  // noinspection JSUnusedLocalSymbols
  /**
   * @param {*} msg
   * @param {string} rawText
   * @param {number} curNum
   * @param {number} totalNum
   */
  const onMessage = function (msg, rawText, curNum, totalNum) {
    const from = msg.getFrom();
    const to = msg.getTo();
    if ($scope.parties.indexOf(from) === -1) {
      $scope.parties.push(from);
    }
    if ($scope.parties.indexOf(to) === -1) {
      $scope.parties.push(to);
    }

    msg.conversation = FixConversations.getOrCreate(
      $scope.conversations,
      from,
      to
    );
    if ($scope.conversations.indexOf(msg.conversation) === -1) {
      $scope.conversations.push(msg.conversation);
    }

    msg.expanded = $scope.expand;
    $scope.messages.push(msg);
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };

  /**
   * @param {number} totalNum
   */
  const onComplete = function (totalNum) {
    const parseTimeSpent = new Date().getTime() - parseTimeStart;
    eventPublisher.timing("Analyzer", "Full Parse Time", parseTimeSpent);
    $scope.filter.conversation = $scope.conversations[0];
    $("html, body").animate(
      {
        scrollTop: $("#filterForm").offset().top,
      },
      100
    );
    loading.hide();
    const parsedMessages = $scope.messages.length;
    if (parsedMessages > 0) {
      let fullQuery = "";
      for (let j = 0; j < parsedMessages; j++) {
        fullQuery += $scope.messages[j].source + "\n";
      }
      let totalParsed = storage.incrementCounter(parsedMessages);
      if (totalParsed >= DONATION_THRESHOLD) {
        console.log(`Parsed ${totalParsed} messages. Opening a donate dialog.`);
        $scope.donate();
      }

      $location.search("q", fullQuery);
    } else {
      $location.search("q", "");
    }
  };

  const fixParser = new FixParser("data/fix/dict", onMessage, onComplete);

  /**
   * @public
   * @param {boolean} expanded
   */
  $scope.expandMessages = function (expanded) {
    storage.setShowMessageDetails(expanded);
    for (let i = 0; i < $scope.messages.length; i++) {
      const msg = $scope.messages[i];
      msg.expanded = expanded;
    }
  };

  /**
   *
   * @param {FixMessage} msg
   * @param  filter
   * @return {boolean}
   */
  const applyFilter = function (msg, filter) {
    let result = true;
    storage.setShowAdminMessages(filter.showAdminMessages);
    storage.setShowHeartbeats(filter.showHeartbeats);
    storage.setCaseInsensitive(filter.caseInsensitive);

    if (filter.text) {
      let src = msg.normalizedSource();
      let t = filter.text.trim();
      if (filter.caseInsensitive) {
        t = t.toLowerCase();
        src = src.toLowerCase();
      }
      result &= src.indexOf(t) >= 0;
    }
    if (filter.conversation !== FixConversations.EMPTY) {
      result &= msg.conversation === filter.conversation;
    }

    let visible = true;
    if (msg.isAdmin() && !filter.showAdminMessages) {
      visible = false;
    }
    if (msg.getMessageType() === "HEARTBEAT" && !filter.showHeartbeats) {
      visible = false;
    }
    msg.visible = visible;
    return result;
  };

  $scope.criteriaMatch = function (criteria) {
    return function (item) {
      return applyFilter(item, criteria);
    };
  };

  /**
   * @private
   * @param {File} file
   * @param {function} callback
   */
  const readFile = function (file, callback) {
    const fileReader = new FileReader();
    fileReader.onload = function () {
      const content = this.result;
      callback(content);
    };
    fileReader.readAsText(file);
  };

  /**
   * @public
   * @param {Element} element
   */
  $scope.setFile = function (element) {
    loading.show();
    eventPublisher.event("search", "engagement", "Parse File");
    $scope.$apply(function ($scope) {
      readFile(element.files[0], function (data) {
        $scope.query = data;
        $scope.parse(data);
      });
    });
  };

  $scope.parse = function (rawMessage) {
    loading.show();
    if ($scope.clearOutput) {
      $scope.messages.length = 0;
    }
    $scope.conversations = [FixConversations.EMPTY];
    $scope.filter.conversation = $scope.conversations[0];
    $scope.parties.length = 0;
    eventPublisher.event("search", "engagement", "Parse");
    parseTimeStart = new Date().getTime();
    fixParser.parse(rawMessage, $scope.dialect).then(() => {
      console.debug("Parse complete");
    });
  };

  /**
   * @public
   * @param {FixTag} tag
   */
  $scope.tagClass = function (tag) {
    let c = "";
    if (tag.isHeaderTag()) {
      c += "fixMessageHeader ";
    }
    if (tag.isTrailerTag()) {
      c += "fixMessageTrailer ";
    }
    if (tag.isGroupHeader()) {
      c += "groupHeader ";
    }
    if (tag.isGroup()) {
      c += "group ";
    }
    if (tag.isGroupStart()) {
      c += "start ";
    }
    return c;
  };

  /**
   * @public
   * @param {FixMessage} msg
   */
  $scope.messageIcon = function (msg) {
    if (msg.getMessageType() === "HEARTBEAT") {
      return "fa fa-stethoscope";
    } else if (msg.isAdmin()) {
      return "fa fa-cogs";
    } else {
      return "fa fa-user";
    }
  };

  /**
   * @public
   */
  $scope.clear = function () {
    eventPublisher.event("click", "engagement", "Clear");
    $scope.conversations = [FixConversations.EMPTY];
    $scope.filter.conversation = $scope.conversations[0];
    $scope.query = "";
    $scope.dialect = "auto";
    $scope.messages.length = 0;
    $location.search("q", "");
    textarea.focus();
  };

  /**
   * @public
   */
  $scope.examples = function () {
    loading.show();
    eventPublisher.event("search", "engagement", "Parse Example FIX");
    fetch("data/fix/examples.txt")
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.text();
      })
      .then((text) => {
        $scope.clear();
        $scope.query = text;
        $scope.dialect = "auto";
        $scope.parse($scope.query);
      });
  };

  /**
   * @public
   * @param {FixTag} tag
   */
  $scope.help = function (tag) {
    const fixSpec = tag.message.dialect;

    const ver = fixSpec.substring(4);
    const url = `https://www.onixs.biz/fix-dictionary/${ver}/tagNum_${tag.num}.html`;
    eventPublisher.event(
      "help",
      "engagement",
      fixSpec,
      `${tag.getTagName()}(${tag.num})`
    );
    open(url, "fixprotocol-help");
    // document.getElementById('helpFrame').contentWindow.location.href = url;
    // $('#helpModal').modal({keyboard: true});
  };

  /**
   * @public
   */
  $scope.features = function () {
    eventPublisher.event("click", "engagement", "Features");
  };

  /**
   * @public
   */
  $scope.donate = function () {
    $("#donate").modal("toggle");
    eventPublisher.event(
      "view_promotion",
      "ecommerce",
      "donate",
      `${storage.getCounter()}`
    );
    storage.resetCounter();
  };

  /**
   * @public
   */
  $scope.credits = function () {
    eventPublisher.event("Help", "Credits");
  };

  const scrollupElement = $(".scrollup");

  $(window).scroll(function () {
    const scrollTop = $(this).scrollTop();
    if (scrollTop > 100) {
      scrollupElement.fadeIn();
    } else {
      scrollupElement.fadeOut();
    }
    if (scrollTop > $filterFormTop) {
      $filterForm.addClass("fixed-top");
    } else {
      $filterForm.removeClass("fixed-top");
    }
  });

  textarea.keydown(function (e) {
    if (e.ctrlKey && e.keyCode === 13) {
      e.preventDefault();
      $scope.parse($scope.query); // Ctrl-Enter pressed
    }
  });

  scrollupElement.on("click", function () {
    eventPublisher.event("scroll", "engagement", "Scroll-Up");
    $("html, body").animate({ scrollTop: 0 }, 100);
    textarea.focus();
    textarea.select();
    return false;
  });

  loading.hide();

  if ($scope.query && $scope.query.length > 0) {
    $scope.parse($scope.query);
  }
}

FixParserCtrl.$inject = ["$scope", "$http", "$location", "$window"];
